import { Page } from '@ui/themed';
import { t } from 'i18next';
import { useMemo, useState } from 'react';
import { SparkSuspense } from '../../../components/spark-suspense';
import { withPageProviders } from '../../../context/page-context';
import {
  type CustomDateRange,
  defaultCustomDateRange,
  resolveDateRange,
} from '../../../utils/date-range';
import { SalesPerformanceCard } from '../../home/components/sales-performance-card';
import { ActivityTable } from '../components/activity-table';
import { usePurchases } from '../hooks/use-purchases';
import type { PurchaseType } from '../types';

export const ActivityPage = withPageProviders(ActivityPageContent);

function ActivityPageContent() {
  const [nDays, setNDays] = useState<string>('7');
  const [customRange, setCustomRange] = useState<CustomDateRange>(defaultCustomDateRange);
  const [purchaseType, setPurchaseType] = useState<PurchaseType>('all');

  const { start, end } = useMemo(() => resolveDateRange(nDays, customRange), [nDays, customRange]);

  const purchases = usePurchases({
    dates: { submitted: { gte: start, lte: end } },
    type: purchaseType,
  });

  return (
    <Page title={t('features:activity.pages.activity_page.title')}>
      <SalesPerformanceCard
        allowCustomRange
        nDays={nDays}
        onNDaysChange={setNDays}
        customRange={customRange}
        onCustomRangeChange={setCustomRange}
        purchaseType={purchaseType}
        onPurchaseTypeChange={setPurchaseType}
      />

      <SparkSuspense
        isLoading={purchases.isLoading}
        isError={purchases.isError}
        errorMessage={t('errors:generic')}
        onReload={purchases.refetch}
      >
        <ActivityTable purchases={purchases.data ?? []} />
      </SparkSuspense>
    </Page>
  );
}
